import tmsApi from './../api/tmsApi';

export default {
  namespaced: true,
  state: {
    location_accuracy: [],
    query: {
      start_date: null,
      end_date: null,
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.location_accuracy.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.location_accuracy.push(data);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    SET_QUERY_DATE(state, dateRange) {
      const [start_date, end_date] = dateRange;
      state.query.start_date = start_date;
      state.query.end_date = end_date;
    },
  },
  getters: {
    location_accuracy(state) {
      return state.location_accuracy;
    },
  },
  actions: {
    LOAD_DATA({ commit, state, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date, end_date } = state.query;

      const query = `
        {
          location_accuracy: order_confirmations(
            start_date: "${start_date}",
            end_date: "${end_date}"
          ) {
            order {
              id
              number
              destination {
                id
              }
            }
            shipment {
              id
              number
              vehicle {
                reg_no
              }
            }
            customer {
              id
              name
              external_id
              address {
                address1
              }
            }
            confirmation {
              name
              created_at
            }
            location_accuracy
            metadata
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'location_accuracy').then(({ data }) => {
        const { location_accuracy } = data;
        location_accuracy.forEach((dt) => {
          commit('ADD_DATA_ON_LIST', dt);
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/location_accuracy.js